import type { ReactNode } from "react";
import { useAuth } from "@/context/AuthContext";
import { isAdmin } from "@/lib/permissions";

/**
 * Renders `children` only for owner/admin roles; otherwise shows a clear
 * "restricted" notice. This is UI gating only — backend authorization remains
 * authoritative and is enforced in the RPCs/policies.
 */
export function AdminOnly({ title, children }: { title: string; children?: ReactNode }) {
  const { role } = useAuth();

  if (isAdmin(role)) return <>{children}</>;

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-semibold text-slate-900 tracking-tight">{title}</h1>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
        <div className="w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center mx-auto mb-3">
          <i className="ri-lock-line text-slate-400 text-xl" aria-hidden="true" />
        </div>
        <p className="text-sm text-slate-600">This area is restricted to administrators.</p>
        <p className="text-xs text-slate-400 mt-1">Ask an administrator if you need access.</p>
      </div>
    </div>
  );
}